import { AppDispatch, Store } from 'store';
import getQueryStringHash from 'utils/routes/getQueryStringHash';
import parseSearchPageParamsServer from 'utils/routes/parseSearchPageParamsServer';
import getLastQueryStringHash from '../selector/getLastQueryStringHash';
import { setLastQueryStringHashAction, setSearchParamsAction, setSearchRefetchFlagAction } from '../slice';

const setParamsFromQueryStringOperation =
  (queryString: URLSearchParams | any) => async (dispatch: AppDispatch, getState: () => Store) => {
    const lastQueryStringHash = getLastQueryStringHash(getState());
    const currentSearchParams = parseSearchPageParamsServer(queryString);
    const currentQueryStringHash = getQueryStringHash(currentSearchParams);

    if (lastQueryStringHash !== currentQueryStringHash) {
      dispatch(setSearchParamsAction(currentSearchParams));
      dispatch(setLastQueryStringHashAction(currentQueryStringHash));
      dispatch(setSearchRefetchFlagAction(true));
    }
  };

export default setParamsFromQueryStringOperation;
